<template lang="pug">
  #ChallengeJoinButton()
    WtButton.wt-join-button(
      v-if="challenge.isPvsPChallenge"
      semibold
      :is-router-link="false"
      is-text
      disabled
    )
      span.has-text-special-success Joined
      BIcon.has-text-special-success(icon="check")
    JoinChallengeWithTeam(
      v-else-if="challenge.between === 'groups' && ! challenge.isPvsPChallenge"
      :challenge="challenge"
    )
    WtJoinButton(
      v-else
      :challenge="challenge"
      :is-text="isText"
      :mapVariant="mapVariant"
    )
</template>

<script>
import WtJoinButton from "@@/WtJoinButton/WtJoinButton";
import WtButton from "@@/WtButton/WtButton";
import JoinChallengeWithTeam from "@@/Challenge/JoinChallengeWithTeam";

export default {
  name: "ChallengeJoinButton",

  components: {
    JoinChallengeWithTeam,
    WtJoinButton,
    WtButton
  },

  props: {
    challenge: {
      type: Object,
      default: () => {}
    },
    isText: {
      type: Boolean,
      default: true
    },
    mapVariant: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="sass" scoped></style>
